export default __webpack_public_path__ + "static/media/StartCreating.24d179d2.mp4";